import { render, staticRenderFns } from "./B2COrderList.vue?vue&type=template&id=2ca9046a&scoped=true&"
import script from "./B2COrderList.vue?vue&type=script&lang=js&"
export * from "./B2COrderList.vue?vue&type=script&lang=js&"
import style0 from "./B2COrderList.vue?vue&type=style&index=0&id=2ca9046a&scoped=true&lang=css&"
import style1 from "./B2COrderList.vue?vue&type=style&index=1&id=2ca9046a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9046a",
  null
  
)

export default component.exports